// extracted by mini-css-extract-plugin
export default {"wrapper":"TodoForm_wrapper__qqhmL","dark":"TodoForm_dark__HctV5","input":"TodoForm_input__YZFFd","light":"TodoForm_light__oewGL","button":"TodoForm_button__VuXA9"};